import React from 'react';
import { leadState, TypeCycleState } from './heroTypeCycle';
import type { HeroSlide } from './heroSlides';

type HeroLeadProps = {
  slides: HeroSlide[];
  cycle: TypeCycleState;
  reduced: boolean;
};

// WU-HERO: the line under the typed headline. It does not type: it fades out as the headline erases and
// rises in as the next one types. It changes its words only while invisible (the gap after the fade-out).
// The hidden ghosts hold the height of the longest line, so nothing below moves.
const HeroLead: React.FC<HeroLeadProps> = ({ slides, cycle, reduced }) => {
  const slide = slides[reduced ? 0 : cycle.phraseIndex] ?? slides[0];
  const state = reduced ? 'in' : leadState(cycle.phase);

  return (
    <div className="hero-lead">
      {slides.map((ghost) => (
        <p key={ghost.key} className="hero-lead__ghost" aria-hidden="true">
          {ghost.body}
        </p>
      ))}
      <p className={`hero-lead__line hero-lead__line--${state}`} aria-hidden="true">
        {slide.body}
      </p>
      <p className="sr-only">{slides[0].body}</p>
    </div>
  );
};

export default HeroLead;
